import React from "react";
import Select from "react-select";
import { ButtonGroup, Button } from "aible";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUp,
  faArrowDown,
  faArrowCircleUp,
  faArrowCircleDown,
  faEye,
  faCog,
  faThumbsUp,
  faThumbsDown,
  faCheckCircle,
  faExclamationTriangle
} from "@fortawesome/free-solid-svg-icons";

import SelectedFeatureChart from "components/FeatureChart/SelectedFeatureChart";
import FeatureChartContainer from "containers/FeatureChart/FeatureChart";
import PartialDepPlotContainer from "containers/RunPlot/PartialDepPlot";
import DriverGraphContainer from "containers/RunPlot/DriverGraph";
import WizardModelContainer from "containers/Wizard/WizardModel";

import LeakageChartContainer from "containers/Next/Charts/LeakageChart";
import NextChartContainer from "components/Next/Charts/NextChart";
import NextSearchContainer from "containers/Next/NextSearch";

import ChooseProcessLimitFrontierContainer from "containers/CreateWizard/Constraints/ChooseProcessLimitFrontier";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";
import { LineInput } from "components/Inputs/LineInput";

import CapSlider from "components/Project/CapSlider";

import BullseyeBlue from "images/bullseye-arrow-light-blue.svg";
import BullseyeLight from "images/bullseye-arrow-light.svg";
import AcademicBlue from "images/academic-blu.svg";
import ThumbsUp from "images/tup.svg";
import ThumbsDown from "images/tdown.svg";
import SettingsIcon from "images/settings.svg";

import { STEP_TYPE, WIZARD_SECTIONS, ORIGINAL_STEPS } from "containers/Wizard/reducer";
import { PROJECT_MODES } from "containers/Run/reducer";

import { isEnabled } from "utils/featureFlags";

import PinnedIcon from "images/Sense-Icons/pinned.svg";
import UnpinnedIcon from "images/Sense-Icons/unpinned.svg";

import styles from "./style.module.css";

export default class GoogleExplore extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      searchColumn: undefined
    };
  }

  renderGoodChart() {
    const { searchColumn } = this.state;

    return (
      <div className={styles.goodBox} style={{ background: "rgba(220, 245, 235, 1)" }}>
        <div className={styles.gIcon}>
          <FontAwesomeIcon icon={faCheckCircle} style={{ color: "#34D399" }} />
        </div>
        <div>
          <div className={styles.wBold}>{"This is a good chart to keep"}</div>
          {"A strong relationship exists between " + searchColumn + " and all other variables"}
        </div>
      </div>
    );
  }

  renderBadChart() {
    return (
      <div className={styles.goodBox} style={{ background: "rgba(248, 230, 194, 1)" }}>
        <div className={styles.gIcon}>
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </div>
        <div>
          <div className={styles.wBold}>{"This may be a misleading chart"}</div>
          {"Charts where a variable with low quality is in the horizontal axis " +
            "may be statistically less informative and might mislead you."}
        </div>
      </div>
    );
  }

  render() {
    const {
      dataset,
      handleSearchInsights,
      nextSearchInsights,
      updateTableauDataId,
      tableauDataId,
      nextTableauDataId,
      nextId
    } = this.props;
    const { searchColumn } = this.state;

    const searchScores = dataset?.interaction_scores_lookup?.[searchColumn] ?? {};

    const goodScore = Object.keys(searchScores)
      .filter((fKey) => fKey != searchScores)
      .map((fKey) => searchScores[fKey])
      .reduce((x, y) => x + y, 0);

    const isGood = goodScore > 0.1;

    return (
      <div className={styles.tableauExplore}>
        <div className={styles.topHeader}>
          <img src={BullseyeLight} style={{ height: "20px", width: "20px", marginRight: "5px" }} />
          {"Insights about what impacts"}
          <span style={{ fontWeight: "bold", marginLeft: "3px" }}>{dataset?.outcome}</span>
        </div>
        <NextSearchContainer
          id={nextId}
          datasetId={dataset?.id}
          isOnlySearch
          updateSearchColumnState={(s) => this.setState({ searchColumn: s })}
        />
        <div style={{ height: "60px" }} />
        <div className={styles.exploreList}>
          {searchColumn === undefined ? <div /> : isGood ? this.renderGoodChart() : this.renderBadChart()}
          <div className={styles.mHolder}>
            <div className={styles.muscleChart} style={nextSearchInsights ? { pointerEvents: "none" } : {}}>
              <LeakageChartContainer id={nextId} isGoogle />
            </div>
          </div>
          {nextSearchInsights && (
            <div style={{ marginTop: "50px" }}>
              {nextSearchInsights
                .sort((a, b) =>
                  a?.metadata?.type === "ModelDriver" ? -1 : b?.metadata?.type === "ModelDriver" ? 1 : 0
                )
                .map((node, i) => (
                  <div
                    className={styles.nextChart}
                    style={i % 2 !== 0 ? { background: "#f2f3f7" } : {}}
                    key={"chart_" + i}
                  >
                    <NextChartContainer
                      id={nextId}
                      // TODO: Madness please fix this. To show muscle chart
                      node={{
                        chart: {
                          chart: node,
                          fields: node.fields,
                          narrative: node?.narrative
                        },
                        fields: node.fields
                      }}
                      chart={{ ...node, chart: node.chart }}
                      isReport={true}
                      showTooltip={true}
                      showLeakage={true}
                      isTableauMode={true}
                      isGoogleMode={true}
                    />
                  </div>
                ))}
            </div>
          )}
        </div>
      </div>
    );
  }
}
